import { render, staticRenderFns } from "./snehove-spravodajstvo.vue?vue&type=template&id=e05cf4d0&"
import script from "./snehove-spravodajstvo.vue?vue&type=script&lang=js&"
export * from "./snehove-spravodajstvo.vue?vue&type=script&lang=js&"
import style0 from "./snehove-spravodajstvo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports